import React, { useState, useEffect, useContext } from "react";
import * as Storage from "ts-storage";
import { FirebaseContext } from "./FirebaseContext";

interface CartProp {
  id: number;
  title: string;
  quantity: number;
  price: number;
  image: string;
  getTotalPrice: () => number;
  getQuantity: () => number;
  removeQuantity: () => void;
  addQuantity: () => void;
}

interface Product {
  id: string;
  categoryId: String;
  title: String;
  price: number;
  sale_price: number;
  stars: number;
  thumbnail: String;
  stock: number;
  category: string;
}

interface Category {
  productByCategory: Array<any>;
  name: String;
  slug: String;
}

export const ProductContext = React.createContext<any>([]);

const FirebaseProvider: React.FC<{ children: any }> = ({ children }) => {
  const [cart, setCart] = useState<Array<CartProp>>([]);
  const firebase: any = useContext(FirebaseContext);
  const [loading, setLoading] = useState<boolean>(true);

  // all products
  const [allproducts, setAllProducts] = useState<Array<Product>>([]);
  const [categories, setCategories] = useState<Array<Category>>([]);
  const [productsByCategory, setProductsByCategory] = useState<Array<Product>>(
    []
  );
  const [currentCategorySlug, setCategorySlug] = useState<string>("");
  // console.log("context rendered");

  // categories

  // Cart

  useEffect(() => {
    let cartFromStorage = Storage.get("cart", "asdsad").value;
    // embed cart
    if (cartFromStorage === "asdsad") {
      Storage.set("cart", JSON.stringify([]));
    } else {
      setCart(JSON.parse(cartFromStorage));
    }

    // if(JSON.parse(Storage.get('cart',0)))

    // all products
    firebase
      .products()
      .get()
      .then((querySnapshot: any) => {
        let newArr: Array<Product> = [];

        newArr = querySnapshot.docs.map((doc: any) => {
          let newObject = { id: doc.id, ...doc.data() };
          return newObject;
        });
        setAllProducts(newArr);
        setLoading(false);
      });

    // categories and productByCategory
    setLoading(true);

    firebase
      .categories()
      .get()
      .then((snap: any) => {
        let categories = snap.docs.map((doc: any) => {
          let productByCategory: any = [];

          firebase
            .products()
            .where("categoryId", "==", doc.id)
            .get()
            .then((snap: any) => {
              snap.docs.forEach((doc: any) => {
                let newObject = { id: doc.id, ...doc.data() };
                productByCategory.push(newObject);
              });
            });
          let newCategory = {
            id: doc.id,
            ...doc.data(),
            productByCategory,
          };

          return newCategory;
        });

        setCategories(categories);
        setLoading(false);
      });
  }, [firebase]);

  return (
    <ProductContext.Provider
      value={[
        cart,
        setCart,
        allproducts,
        categories,
        loading,
        productsByCategory,
        setCategorySlug,
        setLoading,
        currentCategorySlug,
        setProductsByCategory,
        setAllProducts,
      ]}
    >
      {children}
    </ProductContext.Provider>
  );
};

export default FirebaseProvider;
